import { React, useState } from "react";

import Popover from "@mui/material/Popover";
import Icon from "./Icon/Icon";
import styles from "./FileCard.module.scss";

import DropDownCard from "../DropDownCard/DropDownCard";
import DetailsDialog from "../DetailsModal/DetailsDialog";

import { BsThreeDots } from "react-icons/bs";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";

import { useDispatch, useSelector } from "react-redux";
import { impHandler, deleteHandler } from "../service/actionServices";

function FileCard({ filesList, file, page }) {
  const { _id, filename, isImp } = file;
  const fileNameArr = filename.split(".");
  const fileType = fileNameArr[fileNameArr.length -1]
  const dispatch = useDispatch();
  const userData = useSelector(state => state.user);
  let userId = userData && userData.userId && userData.userId;
  const [detailsOpen, setDetailsOpen] = useState(false);
  const handleDetailsOpen = () => setDetailsOpen(true);
  const handleDetailsClose = () => setDetailsOpen(false);

  let Name = filename.slice(0, filename.indexOf("."));

  const importantHandler = () => {
    dispatch(impHandler(_id, userId, filesList, page));
  };

  const deletedFileHandler = () => {
    dispatch(deleteHandler(_id, userId , filesList, page));
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleActionsMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleActionsMenuClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <div className={styles.FileCard_container}>
        <div className={styles.FileCard_header}>
          <div className={styles.FileCard_actions}>
            {page !== "bin" && (
              <button onClick={importantHandler} className={styles.impCard}>
                {isImp ? (
                  <AiFillStar className={styles.notImpCard} />
                ) : (
                  <AiOutlineStar />
                )}
              </button>
            )}
            <div
              className={page === "bin" ? `${styles.FileCard_threeDots} ${styles.FileCard_threeDotsBin}` : styles.FileCard_threeDots}
              onClick={handleActionsMenuClick}>
              {" "}
              <BsThreeDots />{" "}
            </div>{" "}
          </div>

          <Icon fileType={fileType} />
        </div>
        <h1 className={styles.FileCard_text}>{Name}</h1>

        <div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            className={styles.DropDownCardPopper}
            onClose={handleActionsMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}>
            <DropDownCard
              handleActionsMenuClose={handleActionsMenuClose}
              impHandler={importantHandler}
              deleteHandler={deletedFileHandler}
              _id={_id}
              file={file}
              handleDetailsOpen={handleDetailsOpen}
              page={page}
              filesList={filesList}
            />
          </Popover>
          <DetailsDialog
            open={detailsOpen}
            handleClose={handleDetailsClose}
            file={file}
          />
        </div>
      </div>
    </>
  );
}

export default FileCard;
